import { render, staticRenderFns } from "./ProfileResume.vue?vue&type=template&id=0d9baf62"
import script from "./ProfileResume.vue?vue&type=script&lang=js"
export * from "./ProfileResume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports